import { useBestaetigung } from '@pilot-hub/ui'

/** Bestätigung für „Alle Pflichtpunkte ok“ (Vor-, Nach-, Einsatz-Checklisten): verhindert blindes Durchhaken. */
export function useAlleOk() {
  const { bestaetigen, dialog } = useBestaetigung()
  const frage = (offen?: number) => bestaetigen({
    titel: 'Alle Pflichtpunkte als erledigt markieren?',
    text: offen != null ? `${offen} offene Pflichtpunkte werden auf „ok“ gesetzt.` : 'Alle offenen Pflichtpunkte werden auf „ok“ gesetzt.',
    hinweis: 'Nur bestätigen, wenn du jeden Punkt tatsächlich geprüft hast.',
    bestaetigenText: 'Alle ok', gefahr: false,
  })
  return { frage, dialog }
}
